export default __webpack_public_path__ + "static/media/logo.309d2777.png";